import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#fff\" fill-rule=\"evenodd\" d=\"M18.991 10.794a.98.98 0 1 1 1.4 1.371l-5.215 6.516a.98.98 0 0 1-1.41.026l-3.451-3.452a.979.979 0 1 1 1.381-1.387l2.734 2.733 4.535-5.778z\"></path><path fill=\"none\" d=\"M8 7.5h15v15H8z\"></path><g fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" data-name=\"Ellipse 206\"><circle cx=\"15\" cy=\"15\" r=\"15\" stroke=\"none\"></circle><circle cx=\"15\" cy=\"15\" r=\"14\"></circle></g>", 3)
  ])))
}
export default { render: render }